import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '../constants/services';
import './ServiceGrid.css';

const ServiceGrid = () => (
  <div className="service-grid">
    {SERVICES.map((service) => (
      <article key={service.title} className="service-grid__card">
        <div className="service-grid__media">
          <img src={service.image} alt={service.title} />
        </div>
        <div className="service-grid__body">
          <h3 className="service-grid__title">{service.title}</h3>
          <p className="service-grid__text">{service.description}</p>
          <Link to={service.link} className="service-grid__link">
            Learn more
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      </article>
    ))}
  </div>
);

export default ServiceGrid;
